module.exports = __webpack_public_path__ + "static/media/gls_leg_r.5bd9ec05.png";